/**
 * MIME type mapping for common file extensions
 */
export const mimeTypes: Record<string, string> = {
  csv: 'text/csv',
  json: 'application/json',
  txt: 'text/plain',
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  xml: 'application/xml',
  zip: 'application/zip',
};

/**
 * Gets MIME type from file extension
 */
export const getMimeTypeFromExtension = (filename: string): string => {
  const ext = filename.split('.').pop()?.toLowerCase();
  return mimeTypes[ext || ''] || 'application/octet-stream';
};

/**
 * Parses a data URI and extracts the base64 data and MIME type
 * Handles formats like:
 * - data:mime/type;base64,data
 * - data:mime/type;name=...;base64,data
 * @param dataUri - The data URI string to parse
 * @returns Object with base64Data and mimeType, or null if not a valid data URI
 */
export const parseDataUri = (dataUri: string): { base64Data: string; mimeType?: string } | null => {
  // Match data URI format: data:[mime/type][;param=value]*;base64,<data>
  const match = dataUri.match(/^data:([^;]+)(?:;[^;]+)*;base64,(.+)$/);
  if (!match) {
    return null;
  }

  const [, mimeType, base64Data] = match;
  return {
    base64Data,
    mimeType,
  };
};
